import { render } from "./CommonLayout.vue?vue&type=template&id=5f4050ba&scoped=true"
import script from "./CommonLayout.vue?vue&type=script&lang=js"
export * from "./CommonLayout.vue?vue&type=script&lang=js"

import "./CommonLayout.vue?vue&type=style&index=0&id=5f4050ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4050ba"]])

export default __exports__